import { render, staticRenderFns } from "./EchartsBar.vue?vue&type=template&id=2476cb13&scoped=true&"
import script from "./EchartsBar.vue?vue&type=script&lang=js&"
export * from "./EchartsBar.vue?vue&type=script&lang=js&"
import style0 from "./EchartsBar.vue?vue&type=style&index=0&id=2476cb13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2476cb13",
  null
  
)

export default component.exports